import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Group, GroupMember, User } from '@rocksoft/security-sdk';

export function selectGroupMemberIdFromParent(groupMember: GroupMember) {
  return groupMember.parentId ? `${groupMember.parentId}-${groupMember.id}` : groupMember.id;
}

export function createMemberUserFromGroup(user: User, parentGroup: Group) {
  const memberUser: GroupMember = {
    id: user.id,
    email: user.email,
    displayName: user.displayName,
    parentId: parentGroup.id,
  };

  return memberUser;
}

export const adapter: EntityAdapter<GroupMember> = createEntityAdapter<GroupMember>({
  selectId: selectGroupMemberIdFromParent,
});

export type MemberUserState = EntityState<GroupMember>;

export const initialstate: MemberUserState = adapter.getInitialState();
